import { useEffect, useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

// Admin: Bonusfragen-Deadlines überschreiben.
// Leer = automatisch (Pre-Season: Kickoff des ersten Spiels der Saison,
// Playoffs: Kickoff des ersten Playoff-Spiels). Gesetzt = dieser Zeitpunkt.
// Feld: saisonKonfiguration/{id}.bonusfragenDeadlines { preSeason, playoff } (ISO, additiv)

const zuLokal = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const zuIso = (lokal) => (lokal ? new Date(lokal).toISOString() : null);

function BonusDeadlines({ saisonId, config }) {
  const [preSeason, setPreSeason] = useState('');
  const [playoff, setPlayoff] = useState('');
  const [status, setStatus] = useState('');
  const [laedt, setLaedt] = useState(true);

  // Deadlines aus der Konfiguration, die das Admin-Panel schon geladen hat
  useEffect(() => {
    const d = config?.bonusfragenDeadlines || {};
    setPreSeason(zuLokal(d.preSeason));
    setPlayoff(zuLokal(d.playoff));
    setLaedt(false);
  }, [saisonId, config]);

  const speichern = async () => {
    try {
      await setDoc(doc(db, 'saisonKonfiguration', saisonId), {
        bonusfragenDeadlines: { preSeason: zuIso(preSeason), playoff: zuIso(playoff) },
        letzteAenderung: new Date().toISOString()
      }, { merge: true });
      setStatus('✅ Deadlines gespeichert.');
    } catch (error) {
      setStatus('❌ Fehler: ' + error.message);
    }
  };

  const feld = (label, wert, setWert) => (
    <label style={{ display: 'block', marginBottom: 12 }}>
      <span style={{ display: 'block', fontWeight: 'bold', fontSize: 14, marginBottom: 4 }}>{label}</span>
      <input
        type="datetime-local"
        value={wert}
        onChange={e => setWert(e.target.value)}
        style={{ padding: 10, fontSize: 15, borderRadius: 6, border: '1px solid #ccc', minWidth: 240 }}
      />
      {wert && (
        <button type="button" onClick={() => setWert('')} style={{ marginLeft: 8, padding: '8px 12px', border: 'none', borderRadius: 6, background: '#6c757d', color: '#fff', cursor: 'pointer' }}>
          zurück auf automatisch
        </button>
      )}
    </label>
  );

  return (
    <div style={{ backgroundColor: '#f8f9fa', padding: 25, borderRadius: 10, marginBottom: 25 }}>
      <h3>⏰ Deadlines überschreiben</h3>
      <p style={{ color: '#666', fontSize: 14, margin: '5px 0 15px' }}>
        Leer = automatisch (Pre-Season bis zum ersten Spiel der Saison, Playoffs bis zum ersten Playoff-Spiel).
        Mit einem Datum gilt stattdessen dieser Zeitpunkt – z. B. um die Pre-Season-Fragen nach dem ersten Spiel noch einmal zu öffnen.
        Zeiten in deiner lokalen Zeit.
      </p>
      {laedt ? '⏳ lade…' : (
        <>
          {feld('Pre-Season Predictions offen bis', preSeason, setPreSeason)}
          {feld('Playoff Predictions offen bis', playoff, setPlayoff)}
          <button type="button" onClick={speichern} style={{ padding: '10px 20px', border: 'none', borderRadius: 6, background: '#3f3f3f', color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>
            💾 Deadlines speichern
          </button>
          {status && <span style={{ marginLeft: 12, fontSize: 14 }}>{status}</span>}
        </>
      )}
    </div>
  );
}

export default BonusDeadlines;
